import { umsFetcher } from '@/fetchers/umsAPI/base.fetchers';
import { API_CONFIG } from '@/modules/pmt/constants/affiliate.constants';
import type { AffiliateEvent, AffiliateProductsResponse, GetAffiliateProductsParams } from '@/modules/pmt/interfaces';

export type GetAffiliateProducts = (
  params: GetAffiliateProductsParams,
) => Promise<AffiliateProductsResponse | undefined>;

export const getAffiliateProducts: GetAffiliateProducts = async ({
  userUuid,
  locale,
  shipmentId,
  page = 1,
  limit = API_CONFIG.DEFAULT_ITEMS_PER_PAGE,
}) => {
  try {
    // Build query parameters
    const searchParams = new URLSearchParams();
    searchParams.set('locale', locale.toLowerCase());
    searchParams.set('page', page.toString());
    searchParams.set('limit', limit.toString());
    searchParams.set('platform', 'web');

    // Make API call using the base fetcher with userUuid as path parameter
    const response = await umsFetcher.get(`v1/affiliate/products/${userUuid}/${shipmentId}`, {}, searchParams);
    if (response.ok) {
      return (await response.json()) as AffiliateProductsResponse;
    }

    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  } catch (error) {
    console.error('Error fetching affiliate products:', error);
    return undefined;
  }
};

interface AddEventPayload {
  events: AffiliateEvent[];
}

export interface AddEventResponse {
  success: boolean;
  message?: string;
}

type AddEvent = (payload: AddEventPayload, retryAttempt?: number) => Promise<Response>;

export const addEvent: AddEvent = async (payload, retryAttempt) => {
  try {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (retryAttempt !== undefined) {
      headers['X-Retry-Attempt'] = retryAttempt.toString();
    }

    const response = await umsFetcher.post('v1/affiliate/tracking/add-event', payload, { headers });

    return response;
  } catch (err: any) {
    console.error('affiliate/tracking/add-event', err);
    throw err;
  }
};
